<template>
  <div class="col-lg-12 control-section">
 
      <ejs-treeview id='additionalMeasureTreeId'
       ref='additionalMeasureTree' 
      :fields='fields'
       :showCheckBox='true'  
      :nodeChecked='nodeChecked'></ejs-treeview>
 

  </div>
</template>

<script>
import commonUtil from '../RealTimeTask/commonUtil';

export default {
  name: 'AdditionalMeasureTree',
  props: [
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      selectMeasureIds: new Set(),
    };
  },
  methods: {
    init() {
    },

    getMeasureObjectTree() {
        this.$axios.post(`/lte/pm/additionalKpiTree.html?neTypeId=101&neVersionId=V16B.006&timeCycle=2`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          tooltip: 'text'
        };
      });
    },
    nodeChecked(){
       
        if (arguments[0].action == 'check') {
          const nearry =  arguments[0].data.filter(elent => elent.id.split("_").length == 4 );
    
          nearry.forEach(element => {
               this.selectMeasureIds.add(element.id);
          });
           
        }

        if (arguments[0].action == 'uncheck') {
           const nearry =  arguments[0].data.filter(elent => elent.id.split("_").length == 4 );
    
          nearry.forEach(element => {
               this.selectMeasureIds.delete(element.id);
          });
        }
    }
  },
  watch: {
    'measureObjTreeShowType': function (msg) {
    }
  }
};
</script>

<style>

</style>
